import type { DdqSessionQuestion, ResponseTier } from '@/types/api.types';

type UserAction = 'Pending' | 'Accepted' | 'Modified' | 'Rejected';

export interface FilterOptions {
  selectedTiers: ResponseTier[];
  selectedStatuses: UserAction[];
  minConfidence: number;
  maxConfidence: number;
  searchQuery: string;
}

export function filterQuestions(
  questions: DdqSessionQuestion[],
  options: FilterOptions
): DdqSessionQuestion[] {
  let filtered = questions;

  // Apply tier filter
  if (options.selectedTiers.length > 0) {
    filtered = filtered.filter((q) =>
      options.selectedTiers.includes(q.response_tier)
    );
  }

  // Apply status filter
  if (options.selectedStatuses.length > 0) {
    filtered = filtered.filter((q) =>
      options.selectedStatuses.includes(q.userAction || 'Pending')
    );
  }

  // Apply confidence filter
  filtered = filtered.filter(
    (q) =>
      q.confidence >= options.minConfidence &&
      q.confidence <= options.maxConfidence
  );

  // Apply search
  if (options.searchQuery.trim()) {
    const query = options.searchQuery.toLowerCase().trim();
    filtered = filtered.filter(
      (q) =>
        q.incoming_question.toLowerCase().includes(query) ||
        q.suggested_response.toLowerCase().includes(query)
    );
  }

  return filtered;
}
